import { LAYOUT_ACTIONS, LAYOUT_ACTION_TYPES, CellFocusAction } from "../actions/channelLayout"
import { apiStatusInitialState, apiStatusStateType } from "../misc"
import { ChannelLayoutType } from "../../Channel/ChannelDataTypes"
import { CHANNEL_ACTIONS, AddAlertAction } from "../actions/channels"

export interface ChannelLayoutsStateType {
  data: ChannelLayoutType,
  updateAvailable: boolean,
  channelPopup: "updatePrompt" | "alertPrompt" | "none",
  focusedCell: number | false,
  pannedCell: number | false,
  layoutLoaded: boolean,
  fetchStatus: apiStatusStateType
}

export const initialState: ChannelLayoutsStateType = {
  data: {
    channelWidth: 0,
    channelHeight: 0,
    size: 0,
    layout: [],
    boardId: 0,
    centroidCellId: 0,
    activeTag: "",
    layoutConfig: {
      type: "grid"
    }
  },
  updateAvailable: false,
  channelPopup: "none",
  focusedCell: false,
  pannedCell: false,
  layoutLoaded: false,
  fetchStatus: apiStatusInitialState
}

export default (state = initialState, action: LAYOUT_ACTION_TYPES | AddAlertAction): ChannelLayoutsStateType => {

  switch (action.type) {
    case LAYOUT_ACTIONS.FETCH_LAYOUT_START:
      return {
        ...state,
        data: {
          ...state.data,
          layout: []
        },
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        },
        layoutLoaded: false,
      }
    case LAYOUT_ACTIONS.FETCH_LAYOUT_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          data: action.payload,
          updateAvailable: false,
          fetchStatus: {
            ...state.fetchStatus,
            lastFetch: Date.now(),
            errorCode: null,
            developerMessage: null,
            userMessage: null,
            moreInfo: null,
            lastError: null,
            loading: false
          }
        }
      }
      // caution: break is omitted intentionally if the payload is falsey
    case LAYOUT_ACTIONS.FETCH_LAYOUT_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    case LAYOUT_ACTIONS.LAYOUT_UPDATE_BECAME_AVAILABLE:
      // Hide focused cell when layout update becomes unavailable
      return {
        ...state,
        updateAvailable: true,
        channelPopup: "updatePrompt",
        focusedCell: false
      }
    case LAYOUT_ACTIONS.LAYOUT_UPDATE_BECAME_UNAVAILABLE:
      return {
        ...state,
        updateAvailable: false,
        channelPopup: "none",
      }
    // @ts-ignore: Testing
    case "TEST_ALERT_ADDED":
    case CHANNEL_ACTIONS.ALERT_ADDED:
      // Hide focused cell when layout update becomes unavailable
      return {
        ...state,
        channelPopup: "alertPrompt",
        focusedCell: false,
      }
    case LAYOUT_ACTIONS.CELL_FOCUSED:
      return {
        ...state,
        focusedCell: (action as CellFocusAction).payload??false
      }
    case LAYOUT_ACTIONS.CELL_UNFOCUSED:
      return {
        ...state,
        focusedCell: false
      }
    case LAYOUT_ACTIONS.CHANNEL_POPUP_CLOSED:
      return {
        ...state,
        channelPopup: "none"
      }
    case LAYOUT_ACTIONS.PAN_TO_CELL:
      return {
        ...state,
        pannedCell: action.cellId
      }
    case LAYOUT_ACTIONS.STOPPED_PANNING_TO_CELL:
      return {
        ...state,
        pannedCell: false
      }
    case LAYOUT_ACTIONS.LAYOUT_LOADED_SET:
      return {
        ...state,
        layoutLoaded: action.payload
      }
    default:
      return state
  }
}